import { Store, AnalyticsStore } from "bernie-plugin-mobx";
import { SerializedData } from "bernie-core";
import { MabStore, MabExperimentVariant } from "stores/mabStore/MabStore";
import { Logger, NOOP_LOGGER } from "bernie-logger";
import { Action, sendDelayedTrackEvent } from "components/utility/analytics/FlexAnalyticsUtils";
import { FlexContext } from "typings/flexFramework/FlexDefinitions";

/**
 * Calls the mab-grievous-service to get list of MAB-type experiment variants.
 * More info: https://confluence.expedia.biz/display/~knam/MAB+Grievous+Service
 */
export class ClientMabStore extends Store implements MabStore {
  public variants: MabExperimentVariant[] = [];

  constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
  }

  public hydrate(data: SerializedData) {
    Object.assign(this, data);
  }

  // send client-side log event for each variant in format "blossom.mab.<name of experiment>.<variant>.impression"
  // e.g. blossom.mab.potato.4.impression
  public setVariantsAndLog(context: FlexContext | undefined, analytics: AnalyticsStore) {
    this.variants.forEach((mabVariant) => {
      const { name, variant } = mabVariant;

      sendDelayedTrackEvent(
        {
          moduleName: "blossom.mab",
          rfrr: `${name}.${variant}`,
          action: Action.IMPRESSION,
        },
        analytics
      );
    });
  }
}
